import { CancelButton, SaveButton } from "../../elements/ActionButtons/index";
import { Col, FormGroup, Grid, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";

import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
import ContactCards from "../Contact/ContactCards";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import React from "react";
import SlidingPane from "react-sliding-pane";
import SuperpositionHeader from "../Header/SuperpositionHeader";
import TaxParamsCard from "../Tax/TaxParamsCard";
import TiersXtraDataCard from "../Tiers/tiersXtraDataCard";
import SupplierActionButton from "./SupplierActionButton";
import SupplierFormInfos from "./SupplierFormInfos";
import SupplierFormMoreInfos from "./SupplierFormMoreInfos";
import SupplierFormPayment from "./SupplierFormPayment";
import { viewPortDimension } from "../../tools/viewportDimension";
import { withRouter } from "react-router-dom";

// const messages = defineMessages({
//   // eslint-disable-line no-unused-vars
// });

class SupplierForm extends React.Component {
  constructor(props) {
    super(props);
    // let country =
    //   this.props.companyDefaultInfos &&
    //   this.props.companyDefaultInfos.company &&
    //   this.props.companyDefaultInfos.company.addresses &&
    //   this.props.companyDefaultInfos.company.addresses[0].country &&
    //   this.props.companyDefaultInfos.company.addresses[0].country.id;

    // console.log("34 - this.props=", this.props);

    let country =
      this.props.companyDefaultInfos &&
      this.props.companyDefaultInfos.company &&
      this.props.companyDefaultInfos.company.addresses &&
      this.props.companyDefaultInfos.company.addresses[0].country


    // const country =
    //   (this.props.companyDefaultInfos.company &&
    //     this.props.companyDefaultInfos.company.addresses &&
    //     this.props.companyDefaultInfos.company.addresses[0].country) ||
    //   props.defaultCountry;

    // if (!country)
    //   country =
    //     (props.getDefaultCountry &&
    //       props.getDefaultCountry.country &&
    //       props.getDefaultCountry.country.id) ||
    //     "";

    if (!country)
      country =
        (props.getDefaultCountry &&
          props.getDefaultCountry.country) || null;

    this.INITIAL_STATE = {
      contacts: [
        {
          email: "",
          name: "",
          telFixe: "",
          telMobile: "",
          job: ""
        }
      ],
      numeroTVA: "",
      codeAPE: "",
      siret: "",
      defaultTermDelaisPaiement: "COMPTANT",
      defaultTermNetsFinDeMois: "NETS",
      name: this.props.inputName || "",
      website: "",
      address: "",
      addressId: null,
      zipCode: "",
      city: "",
      country: (country && country.id) || "",
      countryCode: (country && country.label) || "FR",
      // countryCode: "FR",
      taxIdemCompany: this.props.supplier ? this.props.taxIdemCompany : true,
      tax1: this.props.companyDefaultInfos.company.tax1,
      tax2: this.props.companyDefaultInfos.company.tax2,
      taxableValue: this.props.supplier ? this.props.supplier.taxableValue : null,
      externalCodeValue: this.props.supplier ? this.props.supplier.externalCodeValue : "",
      escomptePercentValue: this.props.supplier ? this.props.supplier.escomptePercentValue : "0.0",
      currency: this.props.currency && this.props.currency.id,
      iban: "",
      swift: "",
      isPaneOpen: false
    };

    console.log("props", props);
    this.state = props.supplier ? props.supplier : this.INITIAL_STATE;

    this.state.taxableValue = props.supplier && props.supplier.taxableValue ? props.supplier.taxableValue : "ENCAISSEMENT";
    this.state.externalCodeValue = props.supplier && props.supplier.externalCodeValue ? props.supplier.externalCodeValue : "";
    this.state.escomptePercentValue = props.supplier && props.supplier.escomptePercentValue ? props.supplier.escomptePercentValue : "0.0";

    this.state.isPaneOpen = false;
  }
  addLine() {
    const contacts = this.state.contacts;
    contacts.push({
      email: "",
      name: "",
      telFixe: "",
      telMobile: "",
      job: ""
    });
    this.setState({ contacts });
  }
  removeLine(lineIndex) {
    const contacts = this.state.contacts;
    contacts.splice(lineIndex, 1);
    this.setState({ contacts });
  }
  updateLineValue(lineIndex, key, value) {
    let contacts = this.state.contacts;
    contacts[lineIndex][key] = value;
    this.setState({ contacts });
  }
  updateFormValue(key, target) {
    console.log("updateFormValue", key, target);
    this.setState({
      [key]: target ? target.value : ""
    });
  }
  onCancel() {
    this.setState(
      this.props.supplier ? this.props.supplier : this.INITIAL_STATE
    );
  }
  onSubmit() {
    if (this.state && this.state.name === "") return;

    this.props.onSubmit(this.state);
  }
  handleOnSelected = value => {
    const {
      name,
      address,
      ape, //countryCode,
      siret
    } = value.company;

    let newState = { name };
    if (address) newState.address = address;
    if (ape) newState.codeAPE = ape;
    // if (countryCode) newState.countryCode = countryCode;
    if (siret) newState.siret = siret;

    this.setState(newState);
  };

  showDeleteSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      paneTitleIds: this.props.intl.formatMessage({
        id: "ids_supplierDeletion"
      }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmDeleteSupplier"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_supplierHasBeenDeleted"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_errorSupplierCouldNotBeDeleted"
      }),

      paneConfirmAction: async () => {
        return await this.props.deleteSupplier();
      }
    });
  };

  onPaneConfirm = async event => {
    console.log("OnPaneConfirm 002");

    this.setState({ actionRunning: true });

    let bTest = await this.state.paneConfirmAction(event);

    if (
      bTest &&
      bTest.data &&
      bTest.data.deleteTiersAfterCheck &&
      bTest.data.deleteTiersAfterCheck.result
    ) {
      this.setState({ actionRunning: false });

      let notif = NotificationProvider.getSuccessNotification();
      notif.message = this.state.ids_paneActionSuccess;
      this.props.sendNotification(notif);

      this.setState({ isPaneOpen: false });
      setTimeout(() => {
        this.props.history.push("/suppliers");
      }, 1500);
    } else {
      let notif = NotificationProvider.getFailureNotification();
      notif.message = this.state.ids_paneActionFailed;

      this.setState({ isPaneOpen: false });
      this.props.sendNotification(notif);
    }
  };

  renderActionButton() {
    return (
      <SupplierActionButton
        availableActions={["DELETESUPPLIER"]}
        deleteSupplier={() => {
          console.log("call showDeleteSupplierSlidingPane", this);
          this.showDeleteSlidingPane();
        }}
      />
    );
  }

  renderHeader(backBtnText, supplier) {
    if (!this.props.inSideModal) {

      console.log("196 - ", this.props.checkDelete);
      const hideDeleteButton = this.props.checkDelete === undefined ? false : (
        this.props.checkDelete.loading ||
        this.props.checkDelete.checkOnlyDeleteTiers.result === false
      );
      return (
        <SuperpositionHeader
          backBtnText={backBtnText}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
        >
          <div className="space-between">
            <div>{(!supplier || hideDeleteButton) ? <div /> : this.renderActionButton()}</div>
            {/* <CancelButton onClick={this.onCancel.bind(this)} /> */}
            <SaveButton
              onClick={this.onSubmit.bind(this)}
              className="btn-fill"
            />
          </div>
        </SuperpositionHeader>
      );
    }
    return <div />;
  }

  renderButton() {
    if (this.props.inSideModal) {
      return (
        <div className="side-modal-footer">
          <CancelButton onClick={this.props.cancel} />
          <SaveButton
            onClick={this.onSubmit.bind(this)}
            className="btn-fill pull-right margin-left-20"
          />
        </div>
      );
    }
    return <div />;
  }

  renderForm(address) {
    return (
      <FormGroup>
        <Row>
          <Col sm={6}>
            <SupplierFormInfos
              focusNameInput={this.props.inSideModal}
              handleOnSelected={this.handleOnSelected}
              updateFormValue={this.updateFormValue.bind(this)}
              address={address}
              countryCode={this.state.countryCode}
              country={this.state.country}
              nameSelect={!this.props.supplier}
              name={this.state.name}
            />
          </Col>
          <Col sm={6}>
            <SupplierFormMoreInfos
              updateFormValue={this.updateFormValue.bind(this)}
              website={this.state.website}
              siret={this.state.siret}
              numeroTVA={this.state.numeroTVA}
              codeAPE={this.state.codeAPE}
              group={this.state.group}
            />
          </Col>
        </Row>
        <SupplierFormPayment
          updateFormValue={this.updateFormValue.bind(this)}
          defaultTermDelaisPaiement={this.state.defaultTermDelaisPaiement}
          defaultTermNetsFinDeMois={this.state.defaultTermNetsFinDeMois}
          currency={this.state.currency}
          iban={this.state.iban}
          swift={this.state.swift}
        />
      </FormGroup>
    );
  }

  renderFormContainer(address) {
    if (this.props.inSideModal) {
      return (
        <div>
          {this.renderForm(address)}
          <TaxParamsCard
            blockCreateOnTaxes={this.props.inSideModal}
            companyId={this.props.companyId}
            tax1={this.state.tax1}
            tax2={this.state.tax2}
            sendNotification={this.props.sendNotification}
            onChange={(key, value) => {
              this.setState({ [key]: value });
            }}
            withIdemCheckBox
            taxIdemCompany={this.state.taxIdemCompany}
            taxableValue={this.state.taxableValue}
            intl={this.props.intl}
          />

          <TiersXtraDataCard
            taxableValue={this.state.taxableValue}
            externalCodeValue={this.state.externalCodeValue}
            escomptePercentValue={this.state.escomptePercentValue}
            companyId={this.props.companyId}
            onChange={(key, value) => this.setState({ [key]: value })}
            intl={this.props.intl}
          />

          <ContactCards
            lines={this.state.contacts}
            updateLineValue={this.updateLineValue.bind(this)}
            removeLine={this.removeLine.bind(this)}
            addLine={this.addLine.bind(this)}
            country={this.state.countryCode}
          />
        </div>
      );
    }
    return (
      <div className="main-content">
        <Grid fluid>
          <div className="main-content">
            <Row>
              <Card>{this.renderForm(address)}</Card>
              <TaxParamsCard
                companyId={this.props.companyId}
                tax1={this.state.tax1}
                tax2={this.state.tax2}
                sendNotification={this.props.sendNotification}
                onChange={(key, value) => this.setState({ [key]: value })}
                withIdemCheckBox
                taxIdemCompany={this.state.taxIdemCompany}
                taxableValue={this.state.taxableValue}
                intl={this.props.intl}
              />

              <TiersXtraDataCard
                taxableValue={this.state.taxableValue}
                externalCodeValue={this.state.externalCodeValue}
                escomptePercentValue={this.state.escomptePercentValue}
                companyId={this.props.companyId}
                onChange={(key, value) => this.setState({ [key]: value })}
                intl={this.props.intl}
              />

              <ContactCards
                lines={this.state.contacts}
                updateLineValue={this.updateLineValue.bind(this)}
                removeLine={this.removeLine.bind(this)}
                addLine={this.addLine.bind(this)}
                country={this.state.countryCode}
              />
            </Row>
          </div>
        </Grid>
      </div>
    );
  }

  render() {
    // console.log("SupplierForm render", this.props, this.state);

    let { intl, supplier } = this.props;
    let address = this.state.address && this.state.address.replace("\\n", "\n");
    let backBtnText = !supplier
      ? intl.formatMessage({ id: "ids_newSupplier" })
      : supplier.name || intl.formatMessage({ id: "ids_edit" });

    const dimension = viewPortDimension();
    const slidingPaneWidth =
      Math.min(dimension.width - 200, 800).toString() + "px";

    return (
      <div>
        <SlidingPane
          isOpen={this.state.isPaneOpen}
          title={this.state.paneTitleIds}
          width={slidingPaneWidth}
          onRequestClose={() => this.setState({ isPaneOpen: false })}>
          <div>
            <p>{this.state.paneContentIds}</p>
            <FormGroup>
              <CancelButton
                onClick={() => this.setState({ isPaneOpen: false })}
              />
              <Button
                icon
                fill
                wd
                bsStyle="primary"
                onClick={event => this.onPaneConfirm(event)}>
                <i className="fa fa-lg fa-check" />
                <FormattedMessage id="ids_confirm" />
              </Button>
            </FormGroup>
          </div>
        </SlidingPane>
        {this.renderHeader(backBtnText, supplier)}
        <Grid fluid>
          {this.renderFormContainer(address)}
          {this.renderButton()}
        </Grid>
      </div>
    );
  }
}

export default withRouter(injectIntl(SupplierForm));
